/* eslint-disable @typescript-eslint/no-unused-vars */
import styled from "styled-components";

import { EntityKind } from "models/entityKind";

import ForecastSourceSelect from "./ForecastSourceSelect";
import { useGroupByStore } from "./GroupByStoreProvider";
import MetadataFilterToolbar from "./MetadataFilterToolbar";
import PdenSourceSelect from "./PdenSourceSelect";
import { selectEntityKind, selectLiveSelectedCategory } from "./groupBySelectors";

interface PadMetricsToolbarProps {
  toolbarActive?: boolean;
  toolbarFocusedIndex?: Maybe<number>;
  onSelectRef?: (index: number, selectEl: Maybe<HTMLElement>) => void;
  hideForecastTrumping?: boolean;
  hideSourceControls?: boolean;
}

function PadMetricsToolbar({
  toolbarActive = false,
  toolbarFocusedIndex = null,
  onSelectRef,
  hideForecastTrumping = false,
  hideSourceControls = false
}: PadMetricsToolbarProps = {}) {
  const selectedCategory = useGroupByStore(selectLiveSelectedCategory);
  const entityKind = useGroupByStore(selectEntityKind);

  const metadataFiltersCount = selectedCategory?.metadataFilters?.length ?? 0;
  const pdenSourceIndex = metadataFiltersCount;
  const forecastSourceIndex =
    metadataFiltersCount + (entityKind === EntityKind.Well ? 1 : 0);
  const rescatIndex = forecastSourceIndex + 1;

  return (
    <>
      <MetadataFilterToolbar
        toolbarActive={toolbarActive}
        toolbarFocusedIndex={toolbarFocusedIndex}
        onSelectRef={onSelectRef}
      />

      {!hideSourceControls && (
        <Wrapper>
          {entityKind === EntityKind.Well && (
            <SelectWrapper>
              <PdenSourceSelect
                showLabel={true}
                isFocused={toolbarActive && toolbarFocusedIndex === pdenSourceIndex}
                onSelectRef={onSelectRef}
                componentIndex={pdenSourceIndex}
              />
            </SelectWrapper>
          )}
          <SelectWrapper>
            <ForecastSourceSelect
              showLabel={true}
              hideForecastTrumping={hideForecastTrumping}
              isFocused={toolbarActive && toolbarFocusedIndex === forecastSourceIndex}
              rescatFocused={toolbarActive && toolbarFocusedIndex === rescatIndex}
              onSelectRef={onSelectRef}
              componentIndex={forecastSourceIndex}
              rescatComponentIndex={rescatIndex}
            />
          </SelectWrapper>
        </Wrapper>
      )}
    </>
  );
}

export default PadMetricsToolbar;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 0 var(--space-4);
`;

const SelectWrapper = styled.div`
  min-width: 100px;
  width: 100%;
  .ant-select {
    width: 100%;
  }
`;

const WrapperRow = styled.div`
  display: flex;
  padding: 0 var(--space-2);
  gap: 10px;
  flex-direction: column;
`;
